<template>
  <div class="container" v-loading="loading">
    <div class="timer" ref="timer">
      <div :class="['timer-item', activeIndex === index ? 'active-timer' : '']" v-for="(item, index) in week" :key="index" ref="dateDivs" @click="selectDate(index)">
        <span> {{ item.date }}</span>
        <span> {{ item.week }}</span>
      </div>
    </div>
    <div class="set-meal" v-for="item in setMealList" :key="item.Name">
      <span class="name">{{ item.Name }}</span>
      <span class="value">{{ item.MealType }}</span>
    </div>
    <div class="botton-box">
      <div @click="openFilter(true)" class="filter-btn">
        <el-image class="filter-image" :src="shaixuan"></el-image>
        <span>筛选</span>
      </div>
      <el-select size="mini" class="select" v-model="selectMeal" @change="batchMeal" placeholder="批量选择">
        <el-option v-for="item in setMealList" :key="item.Id" :label="item.Name" :value="item.Id"> </el-option>
      </el-select>
      <div class="submit" @click="sumbit">保存</div>
    </div>
    <div class="user-list">
      <div class="list-item" v-for="(item, index) in filterUserList" :key="item.RoomNo">
        <span class="card-number">{{ item.RoomNo }}</span>
        <span class="value">{{ item.Name }}</span>
        <div class="meal-menu">
          <span v-for="itemx in setMealList" :class="['meal', item.ProgrammeTypeId === itemx.Id ? 'avtive-meal' : '']" :key="itemx.Id" @click="setMeal(item, itemx, index)">
            {{ itemx.Name }}
          </span>
        </div>
      </div>
    </div>
    <!-- 筛选 -->

    <el-drawer :class="[isApp ? '' : 'drawer']" direction="ltr" size="71%" :visible.sync="swtich" :before-close="handleClose" :with-header="false">
      <div class="filter" v-loading.fullscreen.lock="filterscreenLoading">
        <div class="close-swtich" @click="handleClose">
          <span class="title">收缩</span>
          <el-image class="left-image" slot="prefix" :src="nvaLeft" fit="contain"></el-image>
        </div>
        <el-menu class="el-menu-vertical-demo" background-color="#fff" text-color="#000">
          <template>
            <el-submenu index="1">
              <template slot="title">
                <span class="title">楼栋</span>
              </template>
              <el-menu-item index="1-1">
                <el-checkbox-group @change="localUpdateFilter({ arr: $event, type: 0 })" v-model="activeBuildings">
                  <el-checkbox-button v-for="building in buildingAreas" :label="building.Name" :key="building.Name">{{ building.Name }}</el-checkbox-button>
                </el-checkbox-group>
              </el-menu-item>
            </el-submenu>

            <el-submenu index="2">
              <template slot="title">
                <span class="title">楼层</span>
              </template>
              <el-menu-item index="2-1">
                <el-checkbox-group @change="localUpdateFilter({ arr: $event, type: 1 })" v-model="activeFloors">
                  <template v-for="building in buildingAreas">
                    <template v-for="floor in building.Floors">
                      <el-checkbox-button v-if="activeBuildings.length == 0 || activeBuildings.indexOf(building.Name) != -1" :key="floor.Name" :label="building.Name + '||' + floor.Name">{{
                        floor.Name
                      }}</el-checkbox-button>
                    </template>
                  </template>
                </el-checkbox-group>
              </el-menu-item>
            </el-submenu>

            <el-submenu index="3">
              <template slot="title">
                <span class="title">房间</span>
              </template>
              <el-menu-item index="3-1">
                <el-checkbox-group @change="localUpdateFilter({ arr: $event, type: 2 })" v-model="activeRomms">
                  <template v-for="building in buildingAreas">
                    <template v-if="activeBuildings.length == 0 || activeBuildings.indexOf(building.Name) != -1">
                      <template v-for="floor in building.Floors">
                        <template v-if="activeFloors.length == 0 || activeFloors.indexOf(building.Name + '||' + floor.Name) != -1">
                          <el-checkbox-button v-for="room in floor.Rooms" :key="room" :label="building.Name + '||' + floor.Name + '||' + room">
                            {{ room }}
                          </el-checkbox-button>
                        </template>
                      </template>
                    </template>
                  </template>
                </el-checkbox-group>
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import shaixuan from '@/assets/imgs/icon-shaixuan-32@2x.png'
import nvaLeft from '@/assets/imgs/left@2x (2).png'
export default {
  data() {
    return {
      isApp: true,
      userId: '',
      loading: false,
      filterscreenLoading: false,
      swtich: false,
      dataUpdate: false,
      shaixuan,
      nvaLeft,
      buildingAreas: [],
      districtData: [],
      FloorData: [],
      roomData: [],
      //选中楼区 楼层 房间
      activeBuildings: [],
      activeFloors: [],
      activeRomms: [],
      areaArr: [],
      floorArr: [],
      roomArr: [],
      userList: [],
      filterUserList: [],
      week: [],
      activeIndex: 0,
      selectMeal: '',
      setMealList: [],
      filterParams: {},
      today: ''
    }
  },
  created() {
    this.isApp = localStorage.getItem('isApp') === '0'
    this.week = this.getWeekDates()
    console.log(this.week)
    const today = new Date()
    const formattedToday = `${today.getMonth() + 1}月${today.getDate()}日`
    this.activeIndex = this.week.findIndex((val) => {
      if (val.date === formattedToday) {
        return (val.value = '(今天)')
      }
    })
    this.today = this.week[this.activeIndex].numDate
    this.getData()
    this.getUserData()
    this.$nextTick(() => this.scrollToSelectedDate())
    this.userId = JSON.parse(localStorage.getItem('user')).UserId
    this.searchData()
  },
  methods: {
    // 获取当天套餐
    getData() {
      this.$axios.get('/Pad/MealShemeList?dateTime=' + this.today).then((res) => {
        this.setMealList = res.data.obj
      })
    },
    // 查询长者列表
    getUserData() {
      this.loading = true
      this.$axios
        .get('/Pad/QueryResidentElderly?startWeek=' + this.today + '&endWeek=' + this.today)
        .then((res) => {
          this.loading = false
          res.data.obj.forEach((val) => {
            val.ProgrammeTypeId = val.List[0].ProgrammeTypeId
          })
          this.userList = res.data.obj
          if (JSON.stringify(this.filterParams) === '{}') {
            this.filterUserList = res.data.obj
          } else {
            this.localUpdateFilter(this.filterParams)
          }
          this.dataUpdate = false
        })
        .catch(() => {
          this.dataUpdate = false
          this.loading = false
        })
    },
    // 获取日期
    getWeekDates() {
      const currentDate = new Date()
      const currentYear = currentDate.getFullYear()
      const currentMonth = currentDate.getMonth()
      const currentDay = currentDate.getDate()

      const dates = []

      // 获取当前日期是一周中的第几天（0-6，0代表星期天）
      const currentDayOfWeek = currentDate.getDay()

      // 计算当前周的第一天（星期一为一周的第一天）
      const firstDayOfCurrentWeek = new Date(currentYear, currentMonth, currentDay - currentDayOfWeek + (currentDayOfWeek === 0 ? -6 : 1))

      // 计算未来一周的日期
      for (let i = 0; i < 14; i++) {
        const date = new Date(firstDayOfCurrentWeek.getFullYear(), firstDayOfCurrentWeek.getMonth(), firstDayOfCurrentWeek.getDate() + i)
        const month = date.getMonth() + 1
        const day = date.getDate()
        const week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'][date.getDay()]
        dates.push({
          date: month + '月' + day + '日',
          numDate: date.getFullYear() + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day),
          week: week
        })
      }

      return dates
    },

    // 点击时间
    selectDate(index) {
      if (this.dataUpdate) {
        this.$confirm('您修改的内容暂未保存,是否保存当前修改', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            const params = {
              dt: this.today,
              list: this.filterUserList
            }
            this.$axios.post('/Pad/MealShemePlanEdit', params).then((res) => {
              this.$message.success({
                message: '保存成功',
                offset: 100
              })
              this.changeDate(index)
            })
          })
          .catch(() => {
            this.changeDate(index)
          })
      } else {
        this.changeDate(index)
      }
    },
    // 切换时间
    changeDate(index) {
      this.activeIndex = index
      this.scrollToSelectedDate()
      this.today = this.week[this.activeIndex].numDate
      this.selectMeal = ''
      this.getData()
      this.getUserData()
    },
    // 滚动时间
    scrollToSelectedDate() {
      const selectedDateDiv = this.$refs.dateDivs[this.activeIndex]
      if (selectedDateDiv) {
        const container = this.$refs.timer
        const containerWidth = container.clientWidth
        const selectedDateLeft = selectedDateDiv.offsetLeft
        const selectedDateWidth = selectedDateDiv.clientWidth
        const targetScroll = selectedDateLeft - (containerWidth - selectedDateWidth) / 2

        // 开始滚动动画
        this.animateScroll(container.scrollLeft, targetScroll)
      }
    },
    // 滚动动画
    animateScroll(startScroll, targetScroll) {
      function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
      }
      const container = this.$refs.timer
      const duration = 500 // 滚动动画的持续时间
      const startTime = performance.now()

      const animate = (currentTime) => {
        const elapsedTime = currentTime - startTime
        const progress = Math.min(elapsedTime / duration, 1)
        const easedProgress = easeInOutQuad(progress)

        container.scrollLeft = startScroll + (targetScroll - startScroll) * easedProgress

        if (progress < 1) {
          requestAnimationFrame(animate)
        }
      }

      requestAnimationFrame(animate)
    },
    // 选择套餐
    setMeal(user, meal, index) {
      this.dataUpdate = true
      user.ProgrammeTypeId = meal.Id
      this.$set(this.filterUserList, index, user)
    },
    // 批量选择
    batchMeal() {
      const list = this.filterUserList.map((val) => {
        val.ProgrammeTypeId = this.selectMeal
        return val
      })
      this.dataUpdate = true
      this.filterUserList = list
    },

    // 筛选---------------------------------------------------
    handleClose() {
      this.swtich = false
    },
    openFilter() {
      this.swtich = true
    },

    // 左侧筛选条件
    localUpdateFilter({ type, arr }) {
      console.log('{type,arr}: ', { type, arr })
      this.filterParams = { type, arr }
      switch (type) {
        case 0:
          this.areaArr = arr
          this.floorArr = []
          this.roomArr = []
          this.activeFloors = []
          this.activeRomms = []
          break
        case 1:
          this.floorArr = arr
          this.roomArr = []
          this.activeRomms = []
          break
        case 2:
          this.roomArr = arr
          break
        default:
          break
      }

      if (this.roomArr.length > 0) {
        this.filterUser([], this.roomArr)
      } else if (this.floorArr.length > 0) {
        let floorArr = []
        this.floorArr.forEach((floor) => {
          floorArr.push(floor.split('||')[1])
        })
        this.filterUser(floorArr, [])
      } else if (this.areaArr.length > 0) {
        let floorArr = []
        this.areaArr.forEach((area) => {
          this.buildingAreas.forEach((build) => {
            if (area === build.Name) {
              build.Floors.forEach((floor) => {
                floorArr.push(floor.Name)
              })
            }
          })
        })
        this.filterUser(floorArr, [])
      } else {
        this.filterUser([], [])
      }
      console.log(123)
    },
    // 数据过滤
    filterUser(floorArr, roomArr) {
      this.filterUserList = this.userList

      let filterUserList = []
      if (floorArr && floorArr.length > 0) {
        floorArr.forEach((floor) => {
          this.filterUserList.forEach((user) => {
            if (user.FloorName === floor) {
              filterUserList.push(user)
            }
          })
        })
        this.filterUserList = filterUserList
        console.log('filterUserList: ', filterUserList)
      }
      if (roomArr && roomArr.length > 0) {
        roomArr.forEach((room) => {
          this.filterUserList.forEach((user) => {
            if (user.RoomNo === room.split('||')[2]) {
              filterUserList.push(user)
            }
          })
        })
        this.filterUserList = filterUserList
      }
    },
    // 查询长者筛选数据
    searchData() {
      this.$axios.post('/Pad/FilterQuery?userId=' + this.userId).then((response) => {
        if (response.data.ok) {
          const filtrate = response.data.obj
          this.buildingAreas = filtrate.BuildingAreas
          var districtData = []
          // 遍历项目楼栋中的小类
          this.buildingAreas.forEach((item) => {
            districtData.push({
              Name: item.Name,
              checked: false,
              parent: item.Name,
              child: item.Floors
            })
          })
          this.districtData = districtData
          var floorData = []
          // 遍历项目楼栋中的小类
          this.districtData.forEach((item) => {
            item.child.forEach((ite) => {
              floorData.push({
                Name: ite.Name,
                parent: item.Name,
                child: ite.Rooms,
                checked: false
              })
            })
          })
          this.floorData = floorData
          var roomData = []
          // 遍历项目楼栋中的小类
          this.floorData.forEach((item) => {
            item.child.forEach((ite) => {
              roomData.push({
                parent: item.parent,
                Name: ite,
                parent1: item.Name,
                checked: false
              })
            })
          })
          this.roomData = roomData
        } else {
          this.$message.error({
            message: response.msg,
            offset: 100
          })
        }
      }),
        (err) => {
          return false
        }
    },

    // 保存
    sumbit() {
      this.$confirm('您正在保存当前的修改的内容', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          dt: this.today,
          list: this.filterUserList
        }
        this.$axios.post('/Pad/MealShemePlanEdit', params).then((res) => {
          this.$message.success({
            message: '保存成功',
            offset: 100
          })
          this.getUserData()
        })
      })
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #f4f4f4;
  font-size: 14px;
}

.timer {
  width: 100%;
  display: flex;
  overflow-x: auto;
  box-sizing: border-box;
  background: #fff;
}

.timer::-webkit-scrollbar {
  display: none;
}

.timer-item {
  flex-shrink: 0;
  width: 90px;
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.active-timer {
  background: #029fd1;
  color: #fff;
}

.set-meal {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebebeb;
  background: #fff;
}
.set-meal .name {
  flex-shrink: 0;
  padding: 4px 16px;
  color: black;
}
.set-meal .value {
  flex-shrink: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #666;
}

.user-list {
  flex: 1;
  overflow-y: auto;
  background: #fff;
}
.list-item {
  display: flex;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #ebebeb;
  background: #fff;
}

.user-list .card-number {
  width: 90px;
  text-align: center;
}
.user-list .value {
  width: 60px;
  text-align: center;
}
.user-list .meal-menu {
  flex: 1;
  display: flex;
  justify-content: center;
}
.user-list .meal {
  width: 50px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  margin: 0 5px;
}
.user-list .avtive-meal {
  background: #029fd1;
  color: #fff;
}

.botton-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 6px;
}
.botton-box .submit {
  width: 61px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 12px !important;
  background-color: #029fd1;
  color: #fff;
}
.filter-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 61px;
  height: 24px;
  line-height: 1.3 !important;
  padding: 0px !important;
  border: 1px solid #029fd1;
  color: #029fd1;
  line-height: 24px;
  border-radius: 12px !important;
  background-color: #fff;
  box-sizing: border-box;
}

.filter-image {
  width: 16px;
  height: 16px;
  margin-right: 2px;
}
.select {
  width: 100px;
  /* margin-right: auto; */
}

.drawer {
  top: 44px;
  height: calc(100vh - 44px);
}

.filter {
  width: 266px;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
}
.filter >>> .el-menu-item {
  padding: 0px !important;
}
.filter >>> .el-checkbox-group {
  display: flex;
  flex-flow: wrap;
}
.filter >>> .el-checkbox-button {
  width: 100px;
}
.filter >>> .el-checkbox-button {
  margin: 10px 6px 10px 0px;
}

.filter >>> .el-checkbox-button__inner {
  width: 100%;
  border-radius: 2px !important;
  padding: 6px 6px;
  border: 1px solid #c7c9cc;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #434649;
}
.filter >>> .el-submenu__title {
  padding: 0px !important;
  background-color: rgba(0, 0, 0, 0) !important;
}
.filter >>> .el-menu-item {
  background-color: rgba(0, 0, 0, 0) !important;
}

.filter >>> .el-submenu .el-menu-item,
.filter >>> .el-menu-item,
.filter >>> .el-submenu__title {
  height: auto;
}

.filter >>> .is-checked .el-checkbox-button__inner {
  background: #029fd1 !important;
  color: #fff !important;
}
/* .filter >>> .is-focus .el-checkbox-button__inner:hover{

} */
.el-menu {
  border-right: none;
}

.close-swtich {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 16px;
  margin: 0px 10px 10px 0px;
}
.left-image {
  width: 16px;
  height: 16px;
  margin-left: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/food/index.vue